<div class="d-flex justify-content-between mb-3">
  <div>
    <strong>{{ addressTitle }}</strong
    ><br />
    @if (addressee) {
      <div>
        {{ addressee }}
      </div>
    }
    <span [innerHTML]="multiLineAddress(address)"></span>
  </div>
  @if (additionalAddressTitle) {
    <div>
      <strong>{{ additionalAddressTitle }}</strong
      ><br />
      @if (additionalAddressee) {
        <div>
          {{ additionalAddressee }}
        </div>
      }
      <span [innerHTML]="multiLineAddress(additionalAddress)"></span>
    </div>
  }
  <app-report-value-pairs [summaryItems]="summaryItems" [labelMinWidth]="false"></app-report-value-pairs>
</div>
